module.exports = __webpack_public_path__ + "img/title.3f43895c.png";